
export const ExportGroup = {
    Contracted: 1,
    Insurances: 2,
    OrganizationUnit: 4,
    Users: 8,
    KaratContracted: 16,
    Cafeterie: 32,
    JapTables: 64,
    ApiUsage: 128,
    Offers: 256,

    ListContracts: 1 | 2 | 16 | 32,
    ListOffers: 256,

    All: 1 | 2 | 4 | 8 | 16 | 32 | 64 | 128 | 256
} as const

export type ExportGroup = typeof ExportGroup[keyof typeof ExportGroup]
